import { useEffect, useMemo } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Row } from "react-bootstrap";

import { getInfrastructure } from "../../../redux/slices/InfrastructureSlice";

import CardBlock from "./CardBlock";

import styles from "./FirstBlock.module.scss";

const FirstBlock = () => {
  const dispatch = useDispatch();

  const infrastructureList = useSelector(
    (state) => state.infrastructureList?.infrastructureList ?? [],
    shallowEqual
  );

  useEffect(() => {
    dispatch(getInfrastructure());
  }, [dispatch]);

  const sortedInfrastructure = useMemo(() => {
    return [...infrastructureList].sort((a, b) => (a?.id ?? 0) - (b?.id ?? 0));
  }, [infrastructureList]);

  return (
    <div className={styles.root}>
      <Row xs={1} md={3} className="g-4">
        {sortedInfrastructure.map((n) => (
          <CardBlock {...n} key={n?.id ?? Math.random()} />
        ))}
      </Row>
    </div>
  );
};

export default FirstBlock;
